import { FormItemType } from "../../UI/view/component-map";
import { FormView } from "../../UI/view/form-view";
import { connectView } from "../../UI/view/view";
import { ContainerReadingsChartGrid } from "./container-tracking-chart-grid";
import { containerTrackingSummaryDataSource } from "./container-tracking-summary-list";

export const containerTrackingDetails = {
  pageHeader: 'Liquid Container Readings',
  editMode: true,
  disableDirtyCheck: true,
  breadcrumbs: [
    {
      name: 'Telemetry',
      icon: 'bar-chart',
      to: '/telemetry#liquid%20containers',
    },
  ],
  items: [
    {
      type: FormItemType.masterDetailLayout,
      items: [
        {
          type: FormItemType.infoPane,
          header: (state) => state?.containerTrackingSummary?.current?.data?.containerLabel,
          infoListSelector: ({containerTrackingSummary}) => {
            const data = containerTrackingSummary?.current?.data?.summary;
            const {
              containerLabel, currentLocation, lastKnownLocation,
              trackingDestination, heLevel, hePressure,
              n2Level, n2Pressure, batteryLevel,
              ambientTemperature  
            } = data || {};
            return [
              { label: 'Container Label', link: () => `/assets/liquid-container/${containerLabel}`, value: containerLabel },
              { label: 'Current Location', value: currentLocation },
              { label: 'Last Known Location', value: lastKnownLocation },
              { label: 'Tracking Destination', value: trackingDestination },
              { label: 'He Level', value: heLevel },
              { label: 'He Pressure', value: hePressure },
              { label: 'N2 Level', value: n2Level },
              { label: 'N2 Pressure', value: n2Pressure },
              { label: 'Battery Level', value: batteryLevel },
              { label: 'Ambient Temperature', value: ambientTemperature },
            ]
          }
        },
        {
          type: FormItemType.tab,

          items: [
            {
              label: 'Sensor Readings',
              items: [

                {
                  type: FormItemType.row,
                  items: [
                    {
                      type: FormItemType.fieldset,
                      items: [
                        {
                          type: FormItemType.chart,
                          componentArgs: {
                            enableExport: true,
                            dataSelector: (state) => state.containerTrackingSummary?.current?.data?.data,
                            series: [
                              {
                                name: 'He Level',
                                type: 'line',
                                x: 'readingTs',
                                y: 'heLevel'
                              },
                              {
                                name: 'He Pressure',
                                type: 'line',
                                x: 'readingTs',
                                y: 'hePressure'
                              },
                              {
                                name: 'N2 Level',
                                type: 'line',
                                x: 'readingTs',
                                y: 'n2Level'
                              },
                              {
                                name: 'N2 Pressure',
                                type: 'line',
                                x: 'readingTs',
                                y: 'n2Pressure'
                              },
                            ]
                          }
                        },
                      ]
                    },
                    {
                      type: FormItemType.fieldset,
                      items: [
                        {
                          type: FormItemType.chart,
                          componentArgs: {
                            enableExport: true,
                            dataSelector: (state) => state.containerTrackingSummary?.current?.data?.data,
                            series: [
                              {
                                name: 'Batter Level',
                                type: 'line',
                                x: 'readingTs',
                                y: 'batteryLevel'
                              },
                              {
                                name: 'Ambient Temperature',
                                type: 'line',
                                x: 'readingTs',
                                y: 'ambientTemperature'
                              },

                            ]
                          }
                        },
                      ]
                    },
                  ]
                },
                {
                  type: FormItemType.row,
                  style: { marginLeft: 2, marginRight: 2, marginBottom: 8 },
                  items: [
                    {
                      type: FormItemType.label,
                      label: 'Readings for last (days)',
                      fitToContent: true,
                    },
                    {
                      number: true,
                      name: 'days',
                      blurOnEnter: true,
                      defaultValue: 90,
                      max: 365,
                    },
                  ]
                },
                {
                  type: FormItemType.fieldset,
                  items: [
                    {
                      type: FormItemType.boundingBox,
                      height: 380,
                      items: [
                        {
                          type: FormItemType.customComponent,
                          component: ContainerReadingsChartGrid
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]

        }
      ]
    }
  ]
} as FormView;

export const [ContainerTrackingDetails, ContainerTrackingDetailsRepo] = connectView({ form: containerTrackingDetails, dataSource: containerTrackingSummaryDataSource });